import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  Variant,
  YsoProduct,
  SpecificationMap,
  Image,
  resolveFirstDisplayableImage,
} from '../../../../data/model';
import {YsoProductFormComponent} from '../yso-product-form/yso-product-form.component';

@Component({
  selector: 'app-yso-bundle-item',
  templateUrl: './yso-bundle-item.component.html',
  styleUrls: ['./yso-bundle-item.component.scss'],
  host: {class: 'app-yso-bundle-item'},
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class YsoBundleItemComponent {
  @Input() product: YsoProduct;
  @Input() specificationMap: SpecificationMap;
  @Input() variants: Variant[];
  @Input() isExpanded = false;

  @Output() formReady = new EventEmitter<boolean>();
  @Output() toggleDetails = new EventEmitter<void>();

  @ViewChild('productForm') productForm: YsoProductFormComponent;

  get bundleItemSpecificationMap(): SpecificationMap {
    const map = this.specificationMap || {};
    if (
      this.product?.specifications &&
      this.product.specifications.length > 0
    ) {
      return {
        ...map,
        [this.product.id]: this.product.specifications,
      };
    }
    return map;
  }

  get bundleItemVariants(): Variant[] {
    if (this.product?.variants && this.product.variants.length > 0) {
      return this.product.variants;
    }
    return this.variants || [];
  }

  get image(): Image {
    return resolveFirstDisplayableImage(this.product?.images);
  }

  get hasBundleDescription(): boolean {
    const raw = this.product?.description;
    const text =
      raw && typeof raw === 'string'
        ? raw
            .replace(/<[^>]*>/g, ' ')
            .replace(/&nbsp;/gi, ' ')
            .trim()
        : '';
    return text.length > 0;
  }

  get productDescription(): string {
    if (this.isExpanded) {
      return this.product.description;
    } else {
      return '';
    }
  }

  onFormReady(): void {
    this.formReady.emit(this.productForm?.valid ?? false);
  }

  onToggleDetails(): void {
    this.toggleDetails.emit();
  }
}
